import { defineComponent } from 'vue';

import details_content from "./details_content.vue";

export default defineComponent({
    components: {
        details_content
    },
    emits: ['close'],
    data() {
        return {
            Booking_Changed: false as boolean
        }
    },
    methods: {
        Close() {
            this.$emit('close', this.Booking_Changed);
        },
        Booking_Cancelled(all_cancelled: boolean) {
            this.Booking_Changed = true;
            if (all_cancelled) {
                this.Close();
            }
        },
        On_Key_Down(e: KeyboardEvent) {
            if (e.key === 'Escape') {
                this.Close();
            }
        }
    },
    mounted() {
        document.addEventListener('keydown', this.On_Key_Down);
        document.body.style.overflow = 'hidden';
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.On_Key_Down);
        document.body.style.overflow = '';
    }
});
